import React from 'react'
import Title from '../views/typo/Title'

export default () => <Title>Page Not Found</Title>



// WEBPACK FOOTER //
// ./src/components/pages/NotFoundPage.js